<template>
  <v-alert type="info" class="rounded-0" data-testid="signer-banner">
    You're viewing {{ agency.name }}'s Settings.
    <router-link
      v-if="agency.signerConnections.length === 1"
      :to="{
        name: 'AgentEdit',
        params: { id: agency.signerConnections[0].connectedAdvisorId }
      }"
      class="text-white text-decoration-underline"
    >
      Click here to view
      {{ agency.signerConnections[0].connectedAdvisorName }}'s Settings.
    </router-link>
    <template v-else>
      View one of the following signer's settings:

      <ul>
        <li
          v-for="signer in agency.signerConnections"
          :key="signer.connectedAdvisorId"
        >
          <router-link
            :to="{
              name: 'AgentEdit',
              params: { id: signer.connectedAdvisorId }
            }"
            class="text-white text-decoration-underline"
          >
            View {{ signer.connectedAdvisorName }} Settings
          </router-link>
        </li>
      </ul>
    </template>
  </v-alert>
</template>
<script setup>
import { useAgencySettingsStore } from "@/stores/agency-settings";
import { useSettingsViewStore } from "@/stores/settings-view";
import { computed } from "vue";

const settings = useSettingsViewStore();

const agency = computed(() => {
  if (!settings.currentAgencyId) return null;
  return useAgencySettingsStore(settings.currentAgencyId);
});
</script>
